
import { Record, Union } from "../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { anonRecord_type, float64_type, int32_type, record_type, bool_type, class_type, list_type, option_type, string_type, union_type } from "../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { ofArray, singleton, empty, collect, map as map_1, find, reduce, isEmpty, contains, tryFind, sort, filter, sortBy, tryHead } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { now, compareTo, compare } from "../fable_modules/fable-library-js.5.0.0-rc.2/Date.js";
import { map, defaultArg } from "../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { safeHash, equals } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { concat, interpolate, toText, replace } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { Label, Hierarchy_getDisplayName, Hierarchy_getAllCategoryIdsInHierarchy, Label_$reflection } from "./Category.js";
import { CustomPropertyValueDto_$reflection, CustomProperty_$reflection } from "./PropertyConfiguration.js";
import { Customer, ProblemReportId_$reflection, CommercialData_$reflection, SetId_$reflection, ToolId_$reflection, ConsumableId_$reflection, Customer_$reflection, ConsumableId__get_unwrap, SetId__get_unwrap, StorageId__get_unwrap, ToolId__get_unwrap } from "./Shared.js";
import { ToolEvent_$reflection, Tool_$reflection, Helper_comment } from "./Tool.js";
import { Helper_comment as Helper_comment_1 } from "./Set.js";
import { Helper_comment as Helper_comment_2 } from "./Consumable.js";
import { ConstructionSite_$reflection } from "./User.js";

export class ReportAppType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Mwk", "I24", "Both"];
    }
}

export function ReportAppType_$reflection() {
    return union_type("Shared.Report.ReportAppType", [], ReportAppType, () => [[], [], []]);
}

export class ReportCategory extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["CustomerReport", "AppointmentsAndReservations", "InventoryAndStock", "Consumables", "ProblemReports", "Inspections"];
    }
}

export function ReportCategory_$reflection() {
    return union_type("Shared.Report.ReportCategory", [], ReportCategory, () => [[], [], [], [], [], []]);
}

export class ReportType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ConsumableByCommissionnumber", "ProblemReportsPerTool", "Appointments", "NewToolsByDateRange", "SchoeffmannRetiredToolsWithQRCodeId", "SchoeffmannActiveAndInMaintenanceToolsWithQRCodeId", "ReservationsByDateRange", "PrinzingToolAssignedToReport", "MissedAppointments", "SchoeffmannUserReport", "SBucherConstructionSiteReport", "WasserNordConsumableReport", "ToolsWithNoReservationsByDateRange", "PrinzingGroupedToolsReport", "NotSolvedProblemReports", "OpenAppointmentsReport", "MinimumQuantityReport", "PlannedToolReturnDate", "NextReservations", "PrinzingBaustromConstructionSiteReport", "SwissAthleticReport", "InMaintenanceReport", "PrinzingHebebuehnenConstructionSiteReport", "ReleaseDate", "RetiredLostToolsByDateRange", "StorageSwitch", "ConsumableAssignment", "PrinzingInactiveTools", "DuplicateCheck", "UninspectedTools", "InspectionStatistics", "ConsumableOutputSummed", "InspectionCalendar"];
    }
}

export function ReportType_$reflection() {
    return union_type("Shared.Report.ReportType", [], ReportType, () => [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []]);
}

export class ReportInventoryType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Tool", "ToolWithQuantity", "Set", "Consumable"];
    }
}

export function ReportInventoryType_$reflection() {
    return union_type("Shared.Report.ReportInventoryType", [], ReportInventoryType, () => [[], [], [], []]);
}

function nextReminder(reminderDates) {
    const date_1 = tryHead(sortBy((_arg) => _arg.Date, filter((date) => !date.IsConfirmed, reminderDates), {
        Compare: (x, y) => (compare(x, y) | 0),
    }));
    if (date_1 == null) {
        return undefined;
    }
    else {
        return date_1.Date;
    }
}

function nextReservationStartDate(reservationDates) {
    const startDate_1 = tryHead(sort(filter((startDate) => (compareTo(startDate, now()) >= 0), reservationDates), {
        Compare: (x, y) => (compare(x, y) | 0),
    }));
    if (startDate_1 == null) {
        return undefined;
    }
    else {
        return startDate_1;
    }
}

function locationByStorage(locations, storage) {
    const matchValue = storage.LocationId;
    if (matchValue == null) {
        return "";
    }
    else {
        const locationId = matchValue;
        return defaultArg(map((location_1) => location_1.Name, tryFind((location) => equals(location.Id, locationId), locations)), "");
    }
}

function priceToString(price) {
    return replace(toText(interpolate("%.2f%P() €", [price / 100])), ".", ",");
}

export class ReportInventoryDto extends Record {
    constructor(Id, InventoryType, DisplayName, Manufacturer, Model, Comment$, SerialNumber, State, Storage, Location, QRCodeIds, StorageSpace, StockQuantity, MinimumStockQuantity, StorageId, InventoryNumber, ImageUrl, CurrentLocation, CheckNumber, Labels, PurchasePrice, SupplierArticleNumber, Supplier, ReleaseDate, PurchaseDate, WarrantyDate, NextReminderDate, NextReservationDate, LastInspectionDate, NextInspectionDate, LastHistoryComment, CustomProperties, IsAssignedToSet, SetId, SetName, IsPartOfSet) {
        super();
        this.Id = Id;
        this.InventoryType = InventoryType;
        this.DisplayName = DisplayName;
        this.Manufacturer = Manufacturer;
        this.Model = Model;
        this.Comment = Comment$;
        this.SerialNumber = SerialNumber;
        this.State = State;
        this.Storage = Storage;
        this.Location = Location;
        this.QRCodeIds = QRCodeIds;
        this.StorageSpace = StorageSpace;
        this.StockQuantity = StockQuantity;
        this.MinimumStockQuantity = MinimumStockQuantity;
        this.StorageId = StorageId;
        this.InventoryNumber = InventoryNumber;
        this.ImageUrl = ImageUrl;
        this.CurrentLocation = CurrentLocation;
        this.CheckNumber = CheckNumber;
        this.Labels = Labels;
        this.PurchasePrice = PurchasePrice;
        this.SupplierArticleNumber = SupplierArticleNumber;
        this.Supplier = Supplier;
        this.ReleaseDate = ReleaseDate;
        this.PurchaseDate = PurchaseDate;
        this.WarrantyDate = WarrantyDate;
        this.NextReminderDate = NextReminderDate;
        this.NextReservationDate = NextReservationDate;
        this.LastInspectionDate = LastInspectionDate;
        this.NextInspectionDate = NextInspectionDate;
        this.LastHistoryComment = LastHistoryComment;
        this.CustomProperties = CustomProperties;
        this.IsAssignedToSet = IsAssignedToSet;
        this.SetId = SetId;
        this.SetName = SetName;
        this.IsPartOfSet = IsPartOfSet;
    }
}

export function ReportInventoryDto_$reflection() {
    return record_type("Shared.Report.ReportInventoryDto", [], ReportInventoryDto, () => [["Id", string_type], ["InventoryType", ReportInventoryType_$reflection()], ["DisplayName", string_type], ["Manufacturer", string_type], ["Model", string_type], ["Comment", string_type], ["SerialNumber", string_type], ["State", string_type], ["Storage", string_type], ["Location", string_type], ["QRCodeIds", string_type], ["StorageSpace", string_type], ["StockQuantity", option_type(string_type)], ["MinimumStockQuantity", option_type(string_type)], ["StorageId", string_type], ["InventoryNumber", string_type], ["ImageUrl", string_type], ["CurrentLocation", string_type], ["CheckNumber", string_type], ["Labels", list_type(Label_$reflection())], ["PurchasePrice", string_type], ["SupplierArticleNumber", string_type], ["Supplier", string_type], ["ReleaseDate", option_type(class_type("System.DateTime"))], ["PurchaseDate", option_type(class_type("System.DateTime"))], ["WarrantyDate", option_type(class_type("System.DateTime"))], ["NextReminderDate", option_type(class_type("System.DateTime"))], ["NextReservationDate", option_type(class_type("System.DateTime"))], ["LastInspectionDate", option_type(class_type("System.DateTime"))], ["NextInspectionDate", option_type(class_type("System.DateTime"))], ["LastHistoryComment", string_type], ["CustomProperties", list_type(CustomProperty_$reflection())], ["IsAssignedToSet", bool_type], ["SetId", option_type(string_type)], ["SetName", option_type(string_type)], ["IsPartOfSet", bool_type]]);
}

export function ReportInventoryDto_ParseTool(tool, storage, locations, categories, receivers, sets) {
    let e;
    const assignedSet = tryFind((s) => contains(tool.Id, s.AssignedToolIds, {
        Equals: equals,
        GetHashCode: (x) => (safeHash(x) | 0),
    }), sets);
    const Id = ToolId__get_unwrap(tool.Id);
    const StorageId = StorageId__get_unwrap(storage.Id);
    const Location = locationByStorage(locations, storage);
    const QRCodeIds = isEmpty(tool.QRCodeIds) ? "" : reduce((list_2, code) => concat(list_2, ", ", ...code), tool.QRCodeIds);
    let CurrentLocation;
    const matchValue = tool.AssignedUserId;
    if (matchValue == null) {
        CurrentLocation = "tool.in_storage";
    }
    else {
        const receiverId = matchValue;
        CurrentLocation = find((receiver) => (receiver.Id === receiverId), receivers).Name;
    }
    let Labels;
    const allIds = Hierarchy_getAllCategoryIdsInHierarchy(categories, tool.LabelIds);
    Labels = map_1((c) => (new Label(c.Id, Hierarchy_getDisplayName(categories, c), c.ColorHex, c.VisibleForUserRole, c.ParentLabelId)), filter((category) => contains(category.Id, allIds, {
        Equals: equals,
        GetHashCode: (x_1) => (safeHash(x_1) | 0),
    }), categories));
    const PurchasePrice = defaultArg(map(priceToString, tool.CommercialData.PurchasePrice), "");
    let CheckNumber;
    const matchValue_1 = tool.CustomerSpecific;
    switch (matchValue_1.tag) {
        case 2:
        case 0: {
            CheckNumber = "";
            break;
        }
        default:
            CheckNumber = matchValue_1.fields[0].CheckNumber;
    }
    const NextReservationDate = nextReservationStartDate(map_1((_arg) => _arg.StartDate, tool.Reservations));
    return new ReportInventoryDto(Id, new ReportInventoryType(0, []), tool.DisplayName, tool.Manufacturer, tool.Model, tool.Comment, tool.SerialNumber, tool.State, storage.Name, Location, QRCodeIds, tool.StorageSpace, undefined, undefined, StorageId, tool.InventoryNumber, tool.ImageUrl, CurrentLocation, CheckNumber, Labels, PurchasePrice, tool.CommercialData.SupplierArticleNumber, tool.CommercialData.Supplier, tool.ReleaseDate, tool.CommercialData.PurchaseDate, tool.CommercialData.WarrantyDate, nextReminder(tool.ReminderDates), NextReservationDate, tool.LastInspectionDate, tool.NextInspectionDate, (e = tryHead(tool.Events), (e != null) ? defaultArg(Helper_comment(e), "") : ""), tool.CustomProperties, assignedSet != null, map((_arg_1) => SetId__get_unwrap(_arg_1.Id), assignedSet), map((_arg_2) => _arg_2.MasterData.Name, assignedSet), assignedSet != null);
}

export function ReportInventoryDto_ParseToolWithQuantity(tool, categories) {
    let e;
    const Id = ToolId__get_unwrap(tool.Id);
    let QRCodeIds;
    const qrCodes = collect((x) => x, map_1((_arg) => _arg.QRCodeIds, tool.StockPerStorage));
    QRCodeIds = (isEmpty(qrCodes) ? "" : reduce((list_3, code) => concat(list_3, ", ", ...code), qrCodes));
    let Labels;
    const allIds = Hierarchy_getAllCategoryIdsInHierarchy(categories, tool.LabelIds);
    Labels = map_1((c) => (new Label(c.Id, Hierarchy_getDisplayName(categories, c), c.ColorHex, c.VisibleForUserRole, c.ParentLabelId)), filter((category) => contains(category.Id, allIds, {
        Equals: equals,
        GetHashCode: (x_1) => (safeHash(x_1) | 0),
    }), categories));
    const PurchasePrice = defaultArg(map(priceToString, tool.CommercialData.PurchasePrice), "");
    let CheckNumber;
    const matchValue = tool.CustomerSpecific;
    CheckNumber = ((matchValue.tag === 1) ? matchValue.fields[0].CheckNumber : "");
    const NextReservationDate = nextReservationStartDate(map_1((_arg_1) => _arg_1.StartDate, tool.Reservations));
    return new ReportInventoryDto(Id, new ReportInventoryType(1, []), tool.DisplayName, tool.Manufacturer, tool.Model, tool.Comment, "", "active", "", "", QRCodeIds, "", undefined, undefined, "", tool.InventoryNumber, tool.ImageUrl, "", CheckNumber, Labels, PurchasePrice, tool.CommercialData.SupplierArticleNumber, tool.CommercialData.Supplier, undefined, tool.CommercialData.PurchaseDate, tool.CommercialData.WarrantyDate, nextReminder(tool.ReminderDates), NextReservationDate, undefined, undefined, (e = tryHead(tool.Events), (e != null) ? defaultArg(Helper_comment(e), "") : ""), tool.CustomProperties, false, undefined, undefined, false);
}

export function ReportInventoryDto_ParseSet(set$, storage, locations, categories, receivers) {
    let e;
    const Id = SetId__get_unwrap(set$.Id);
    let State;
    const matchValue = set$.State;
    State = ((matchValue === "retired") ? "retired" : ((matchValue === "active") ? "active" : ((matchValue === "lost") ? "lost" : "inMaintenance")));
    const StorageId = StorageId__get_unwrap(storage.Id);
    const Location = locationByStorage(locations, storage);
    const QRCodeIds = isEmpty(set$.QRCodeIds) ? "" : reduce((list_1, code) => concat(list_1, ", ", ...code), set$.QRCodeIds);
    let CurrentLocation;
    const matchValue_1 = set$.LocationInformation.AssignedReceiverId;
    if (matchValue_1 == null) {
        CurrentLocation = "tool.in_storage";
    }
    else {
        const receiverId = matchValue_1;
        CurrentLocation = find((receiver) => (receiver.Id === receiverId), receivers).Name;
    }
    let Labels;
    const allIds = Hierarchy_getAllCategoryIdsInHierarchy(categories, set$.LabelIds);
    Labels = map_1((c) => (new Label(c.Id, Hierarchy_getDisplayName(categories, c), c.ColorHex, c.VisibleForUserRole, c.ParentLabelId)), filter((category) => contains(category.Id, allIds, {
        Equals: equals,
        GetHashCode: (x) => (safeHash(x) | 0),
    }), categories));
    const PurchasePrice = defaultArg(map(priceToString, set$.MasterData.CommercialData.PurchasePrice), "");
    const NextReservationDate = nextReservationStartDate(map_1((_arg) => _arg.StartDate, set$.Planning.Reservations));
    return new ReportInventoryDto(Id, new ReportInventoryType(2, []), set$.MasterData.Name, set$.MasterData.Manufacturer, set$.MasterData.Model, set$.MasterData.Comment, set$.MasterData.SerialNumber, State, storage.Name, Location, QRCodeIds, set$.LocationInformation.StorageSpace, undefined, undefined, StorageId, set$.MasterData.InventoryNumber, set$.ImageUrl, CurrentLocation, "", Labels, PurchasePrice, set$.MasterData.CommercialData.SupplierArticleNumber, set$.MasterData.CommercialData.Supplier, undefined, set$.MasterData.CommercialData.PurchaseDate, set$.MasterData.CommercialData.WarrantyDate, nextReminder(set$.Planning.ReminderDates), NextReservationDate, undefined, undefined, (e = tryHead(set$.Events), (e != null) ? defaultArg(Helper_comment_1(e), "") : ""), set$.MasterData.CustomProperties, false, undefined, undefined, true);
}

export function ReportInventoryDto_ParseConsumable(consumable, categories) {
    let e;
    const Id = ConsumableId__get_unwrap(consumable.Id);
    let QRCodeIds;
    const qrCodes = collect((x) => x, map_1((_arg) => _arg.QRCodeIds, consumable.StockPerStorage));
    QRCodeIds = (isEmpty(qrCodes) ? "" : reduce((list_3, code) => concat(list_3, ", ", ...code), qrCodes));
    let Labels;
    const allIds = Hierarchy_getAllCategoryIdsInHierarchy(categories, consumable.LabelIds);
    Labels = map_1((c) => (new Label(c.Id, Hierarchy_getDisplayName(categories, c), c.ColorHex, c.VisibleForUserRole, c.ParentLabelId)), filter((category) => contains(category.Id, allIds, {
        Equals: equals,
        GetHashCode: (x_1) => (safeHash(x_1) | 0),
    }), categories));
    const PurchasePrice = defaultArg(map(priceToString, consumable.CommercialData.PurchasePrice), "");
    const NextReservationDate = nextReservationStartDate(map_1((_arg_1) => _arg_1.StartDate, consumable.Reservations));
    return new ReportInventoryDto(Id, new ReportInventoryType(3, []), consumable.Name, "", "", "", "", "active", "", "", QRCodeIds, "", undefined, undefined, "", consumable.InventoryNumber, consumable.ImageUrl, "", "", Labels, PurchasePrice, consumable.CommercialData.SupplierArticleNumber, consumable.CommercialData.Supplier, undefined, consumable.CommercialData.PurchaseDate, consumable.CommercialData.WarrantyDate, nextReminder(consumable.ReminderDates), NextReservationDate, undefined, undefined, (e = tryHead(consumable.Events), (e != null) ? Helper_comment_2(e) : ""), consumable.CustomProperties, false, undefined, undefined, false);
}

export class Report extends Record {
    constructor(Type, WithDaterange, OnlyVisibleForCustomer, Id, I18NLabel, Category) {
        super();
        this.Type = Type;
        this.WithDaterange = WithDaterange;
        this.OnlyVisibleForCustomer = OnlyVisibleForCustomer;
        this.Id = (Id | 0);
        this.I18NLabel = I18NLabel;
        this.Category = Category;
    }
}

export function Report_$reflection() {
    return record_type("Shared.Report.Report", [], Report, () => [["Type", ReportType_$reflection()], ["WithDaterange", bool_type], ["OnlyVisibleForCustomer", list_type(Customer_$reflection())], ["Id", int32_type], ["I18NLabel", string_type], ["Category", ReportCategory_$reflection()]]);
}

export class ConsumableResult extends Record {
    constructor(Id, Name, Unit, CommissionNumber, Quantity) {
        super();
        this.Id = Id;
        this.Name = Name;
        this.Unit = Unit;
        this.CommissionNumber = CommissionNumber;
        this.Quantity = Quantity;
    }
}

export function ConsumableResult_$reflection() {
    return record_type("Shared.Report.ConsumableResult", [], ConsumableResult, () => [["Id", ConsumableId_$reflection()], ["Name", string_type], ["Unit", string_type], ["CommissionNumber", string_type], ["Quantity", float64_type]]);
}

export class ConsumableByCommissionnumber extends Record {
    constructor(ReportType, CommissionNumber, Consumables) {
        super();
        this.ReportType = ReportType;
        this.CommissionNumber = CommissionNumber;
        this.Consumables = Consumables;
    }
}

export function ConsumableByCommissionnumber_$reflection() {
    return record_type("Shared.Report.ConsumableByCommissionnumber", [], ConsumableByCommissionnumber, () => [["ReportType", ReportType_$reflection()], ["CommissionNumber", string_type], ["Consumables", list_type(ConsumableResult_$reflection())]]);
}

export class ProblemReportsPerTool extends Record {
    constructor(ReportType, Id, Tool, SumOfProblemReports, LastProblemReport) {
        super();
        this.ReportType = ReportType;
        this.Id = Id;
        this.Tool = Tool;
        this.SumOfProblemReports = (SumOfProblemReports | 0);
        this.LastProblemReport = LastProblemReport;
    }
}

export function ProblemReportsPerTool_$reflection() {
    return record_type("Shared.Report.ProblemReportsPerTool", [], ProblemReportsPerTool, () => [["ReportType", ReportType_$reflection()], ["Id", ToolId_$reflection()], ["Tool", Tool_$reflection()], ["SumOfProblemReports", int32_type], ["LastProblemReport", class_type("System.DateTime")]]);
}

export class AppointmentIdType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["AppointmentTool", "AppointmentToolWithQuantity", "AppointmentSet", "AppointmentConsumable"];
    }
}

export function AppointmentIdType_$reflection() {
    return union_type("Shared.Report.AppointmentIdType", [], AppointmentIdType, () => [[["Item", ToolId_$reflection()]], [["Item", ToolId_$reflection()]], [["Item", SetId_$reflection()]], [["Item", ConsumableId_$reflection()]]]);
}

export class AppointmentPerTool extends Record {
    constructor(ReminderDate, Title, Description, OpenAppointmentIdType, IsConfirmed, CheckNumber, DisplayName, SerialNumber, CustomProperties) {
        super();
        this.ReminderDate = ReminderDate;
        this.Title = Title;
        this.Description = Description;
        this.OpenAppointmentIdType = OpenAppointmentIdType;
        this.IsConfirmed = IsConfirmed;
        this.CheckNumber = CheckNumber;
        this.DisplayName = DisplayName;
        this.SerialNumber = SerialNumber;
        this.CustomProperties = CustomProperties;
    }
}

export function AppointmentPerTool_$reflection() {
    return record_type("Shared.Report.AppointmentPerTool", [], AppointmentPerTool, () => [["ReminderDate", class_type("System.DateTime")], ["Title", string_type], ["Description", string_type], ["OpenAppointmentIdType", AppointmentIdType_$reflection()], ["IsConfirmed", bool_type], ["CheckNumber", string_type], ["DisplayName", string_type], ["SerialNumber", string_type], ["CustomProperties", list_type(CustomProperty_$reflection())]]);
}

export class OpenAppointment extends Record {
    constructor(ReminderDate, Title, Description, IdType, IsConfirmed, Inventory) {
        super();
        this.ReminderDate = ReminderDate;
        this.Title = Title;
        this.Description = Description;
        this.IdType = IdType;
        this.IsConfirmed = IsConfirmed;
        this.Inventory = Inventory;
    }
}

export function OpenAppointment_$reflection() {
    return record_type("Shared.Report.OpenAppointment", [], OpenAppointment, () => [["ReminderDate", class_type("System.DateTime")], ["Title", string_type], ["Description", string_type], ["IdType", AppointmentIdType_$reflection()], ["IsConfirmed", bool_type], ["Inventory", ReportInventoryDto_$reflection()]]);
}

export class InventoryEntries extends Record {
    constructor(ToolId, Date$, InventoryEntryType, DisplayName, SerialNumber, Model, Manufacturer, InventoryNumber, StorageInformation, CommercialData, CustomProperties) {
        super();
        this.ToolId = ToolId;
        this.Date = Date$;
        this.InventoryEntryType = InventoryEntryType;
        this.DisplayName = DisplayName;
        this.SerialNumber = SerialNumber;
        this.Model = Model;
        this.Manufacturer = Manufacturer;
        this.InventoryNumber = InventoryNumber;
        this.StorageInformation = StorageInformation;
        this.CommercialData = CommercialData;
        this.CustomProperties = CustomProperties;
    }
}

export function InventoryEntries_$reflection() {
    return record_type("Shared.Report.InventoryEntries", [], InventoryEntries, () => [["ToolId", string_type], ["Date", class_type("System.DateTime")], ["InventoryEntryType", string_type], ["DisplayName", string_type], ["SerialNumber", string_type], ["Model", string_type], ["Manufacturer", string_type], ["InventoryNumber", string_type], ["StorageInformation", anonRecord_type(["StorageName", string_type], ["StorageSpace", string_type])], ["CommercialData", CommercialData_$reflection()], ["CustomProperties", list_type(CustomPropertyValueDto_$reflection())]]);
}

export class SchoeffmannRetiredToolWithQRCodeId extends Record {
    constructor(ToolId, QRCodeId, DisplayName, Manufacturer, Model, SerialNumber, StorageName, UpdatedAt, RetiredDate) {
        super();
        this.ToolId = ToolId;
        this.QRCodeId = QRCodeId;
        this.DisplayName = DisplayName;
        this.Manufacturer = Manufacturer;
        this.Model = Model;
        this.SerialNumber = SerialNumber;
        this.StorageName = StorageName;
        this.UpdatedAt = UpdatedAt;
        this.RetiredDate = RetiredDate;
    }
}

export function SchoeffmannRetiredToolWithQRCodeId_$reflection() {
    return record_type("Shared.Report.SchoeffmannRetiredToolWithQRCodeId", [], SchoeffmannRetiredToolWithQRCodeId, () => [["ToolId", ToolId_$reflection()], ["QRCodeId", string_type], ["DisplayName", string_type], ["Manufacturer", string_type], ["Model", string_type], ["SerialNumber", string_type], ["StorageName", string_type], ["UpdatedAt", class_type("System.DateTime")], ["RetiredDate", class_type("System.DateTime")]]);
}

export class SchoeffmannActiveAndInMaintenanceToolWithQRCodeId extends Record {
    constructor(ToolId, QRCodeId, DisplayName, Manufacturer, Model, SerialNumber, State, StorageName, UpdatedAt) {
        super();
        this.ToolId = ToolId;
        this.QRCodeId = QRCodeId;
        this.DisplayName = DisplayName;
        this.Manufacturer = Manufacturer;
        this.Model = Model;
        this.SerialNumber = SerialNumber;
        this.State = State;
        this.StorageName = StorageName;
        this.UpdatedAt = UpdatedAt;
    }
}

export function SchoeffmannActiveAndInMaintenanceToolWithQRCodeId_$reflection() {
    return record_type("Shared.Report.SchoeffmannActiveAndInMaintenanceToolWithQRCodeId", [], SchoeffmannActiveAndInMaintenanceToolWithQRCodeId, () => [["ToolId", ToolId_$reflection()], ["QRCodeId", string_type], ["DisplayName", string_type], ["Manufacturer", string_type], ["Model", string_type], ["SerialNumber", string_type], ["State", string_type], ["StorageName", string_type], ["UpdatedAt", class_type("System.DateTime")]]);
}

export class ReservationsByDateRangeReportItem extends Record {
    constructor(ToolId, SetId, DisplayName, Manufacturer, Model, SerialNumber, ReservationCreatedBy, ReservationForUser, StartDate, EndDate) {
        super();
        this.ToolId = ToolId;
        this.SetId = SetId;
        this.DisplayName = DisplayName;
        this.Manufacturer = Manufacturer;
        this.Model = Model;
        this.SerialNumber = SerialNumber;
        this.ReservationCreatedBy = ReservationCreatedBy;
        this.ReservationForUser = ReservationForUser;
        this.StartDate = StartDate;
        this.EndDate = EndDate;
    }
}

export function ReservationsByDateRangeReportItem_$reflection() {
    return record_type("Shared.Report.ReservationsByDateRangeReportItem", [], ReservationsByDateRangeReportItem, () => [["ToolId", ToolId_$reflection()], ["SetId", option_type(SetId_$reflection())], ["DisplayName", string_type], ["Manufacturer", string_type], ["Model", string_type], ["SerialNumber", string_type], ["ReservationCreatedBy", string_type], ["ReservationForUser", string_type], ["StartDate", class_type("System.DateTime")], ["EndDate", class_type("System.DateTime")]]);
}

export class ToolWithoutReservationsByDateRangeReportItem extends Record {
    constructor(ToolId, DisplayName, Manufacturer, Model, SerialNumber) {
        super();
        this.ToolId = ToolId;
        this.DisplayName = DisplayName;
        this.Manufacturer = Manufacturer;
        this.Model = Model;
        this.SerialNumber = SerialNumber;
    }
}

export function ToolWithoutReservationsByDateRangeReportItem_$reflection() {
    return record_type("Shared.Report.ToolWithoutReservationsByDateRangeReportItem", [], ToolWithoutReservationsByDateRangeReportItem, () => [["ToolId", ToolId_$reflection()], ["DisplayName", string_type], ["Manufacturer", string_type], ["Model", string_type], ["SerialNumber", string_type]]);
}

export class PrinzingToolAssignedTo extends Record {
    constructor(Id, ToolId, LastComment, AssignedUsername, Manufacturer, Model, SerialNumber, DisplayName, InventoryNumber, Checknumber, Quantity, IsToolWithQuantity, IsSet, AssignedDate, PurchasePrice, CustomProperties, LastInspectionDate, NextInspectionDate) {
        super();
        this.Id = Id;
        this.ToolId = ToolId;
        this.LastComment = LastComment;
        this.AssignedUsername = AssignedUsername;
        this.Manufacturer = Manufacturer;
        this.Model = Model;
        this.SerialNumber = SerialNumber;
        this.DisplayName = DisplayName;
        this.InventoryNumber = InventoryNumber;
        this.Checknumber = Checknumber;
        this.Quantity = Quantity;
        this.IsToolWithQuantity = IsToolWithQuantity;
        this.IsSet = IsSet;
        this.AssignedDate = AssignedDate;
        this.PurchasePrice = PurchasePrice;
        this.CustomProperties = CustomProperties;
        this.LastInspectionDate = LastInspectionDate;
        this.NextInspectionDate = NextInspectionDate;
    }
}

export function PrinzingToolAssignedTo_$reflection() {
    return record_type("Shared.Report.PrinzingToolAssignedTo", [], PrinzingToolAssignedTo, () => [["Id", string_type], ["ToolId", string_type], ["LastComment", string_type], ["AssignedUsername", string_type], ["Manufacturer", string_type], ["Model", string_type], ["SerialNumber", string_type], ["DisplayName", string_type], ["InventoryNumber", string_type], ["Checknumber", string_type], ["Quantity", string_type], ["IsToolWithQuantity", bool_type], ["IsSet", bool_type], ["AssignedDate", class_type("System.DateTime")], ["PurchasePrice", option_type(int32_type)], ["CustomProperties", list_type(CustomPropertyValueDto_$reflection())], ["LastInspectionDate", option_type(class_type("System.DateTime"))], ["NextInspectionDate", option_type(class_type("System.DateTime"))]]);
}

export class ConsumableByCommissionnumberDto extends Record {
    constructor(StartDate, EndDate, ReportType, SelectedValue) {
        super();
        this.StartDate = StartDate;
        this.EndDate = EndDate;
        this.ReportType = ReportType;
        this.SelectedValue = SelectedValue;
    }
}

export function ConsumableByCommissionnumberDto_$reflection() {
    return record_type("Shared.Report.ConsumableByCommissionnumberDto", [], ConsumableByCommissionnumberDto, () => [["StartDate", class_type("System.DateTime")], ["EndDate", class_type("System.DateTime")], ["ReportType", ReportType_$reflection()], ["SelectedValue", string_type]]);
}

export class ReportCsvExportDto extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ConsumableByCommissionnumber", "SchoeffmannUserReport", "PrinzingGroupedToolReport", "PrinzingToolAssignedToReport"];
    }
}

export function ReportCsvExportDto_$reflection() {
    return union_type("Shared.Report.ReportCsvExportDto", [], ReportCsvExportDto, () => [[["Item", ConsumableByCommissionnumberDto_$reflection()]], [["userId", string_type]], [], []]);
}

export class SchoeffmannUserReport extends Record {
    constructor(UserName, UserId, QrCodeId, Manufacturer, Model, SerialNumber, State, AssignedTo, LastInspectionDate, NextInspectionDate) {
        super();
        this.UserName = UserName;
        this.UserId = UserId;
        this.QrCodeId = QrCodeId;
        this.Manufacturer = Manufacturer;
        this.Model = Model;
        this.SerialNumber = SerialNumber;
        this.State = State;
        this.AssignedTo = AssignedTo;
        this.LastInspectionDate = LastInspectionDate;
        this.NextInspectionDate = NextInspectionDate;
    }
}

export function SchoeffmannUserReport_$reflection() {
    return record_type("Shared.Report.SchoeffmannUserReport", [], SchoeffmannUserReport, () => [["UserName", string_type], ["UserId", string_type], ["QrCodeId", string_type], ["Manufacturer", string_type], ["Model", string_type], ["SerialNumber", string_type], ["State", string_type], ["AssignedTo", string_type], ["LastInspectionDate", string_type], ["NextInspectionDate", string_type]]);
}

export class SBucherConstructionSiteReport extends Record {
    constructor(Manufacturer, ToolId, Model, InventoryNumber, ConstructionSite, ConstructionSiteId, AssignDate, ReturnDate) {
        super();
        this.Manufacturer = Manufacturer;
        this.ToolId = ToolId;
        this.Model = Model;
        this.InventoryNumber = InventoryNumber;
        this.ConstructionSite = ConstructionSite;
        this.ConstructionSiteId = ConstructionSiteId;
        this.AssignDate = AssignDate;
        this.ReturnDate = ReturnDate;
    }
}

export function SBucherConstructionSiteReport_$reflection() {
    return record_type("Shared.Report.SBucherConstructionSiteReport", [], SBucherConstructionSiteReport, () => [["Manufacturer", string_type], ["ToolId", string_type], ["Model", string_type], ["InventoryNumber", string_type], ["ConstructionSite", string_type], ["ConstructionSiteId", string_type], ["AssignDate", string_type], ["ReturnDate", option_type(string_type)]]);
}

export class WasserNordConsumableReportReceiverType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Storage", "ConstructionSite"];
    }
}

export function WasserNordConsumableReportReceiverType_$reflection() {
    return union_type("Shared.Report.WasserNordConsumableReportReceiverType", [], WasserNordConsumableReportReceiverType, () => [[], []]);
}

export class WasserNordConsumableReport extends Record {
    constructor(Name, AdditionalName, SupplierArticleNumber, ConsumableId, ReceiverName, ReceiverId, SenderName, StorageId, Quantity, ReceiverType, Timestamp) {
        super();
        this.Name = Name;
        this.AdditionalName = AdditionalName;
        this.SupplierArticleNumber = SupplierArticleNumber;
        this.ConsumableId = ConsumableId;
        this.ReceiverName = ReceiverName;
        this.ReceiverId = ReceiverId;
        this.SenderName = SenderName;
        this.StorageId = StorageId;
        this.Quantity = Quantity;
        this.ReceiverType = ReceiverType;
        this.Timestamp = Timestamp;
    }
}

export function WasserNordConsumableReport_$reflection() {
    return record_type("Shared.Report.WasserNordConsumableReport", [], WasserNordConsumableReport, () => [["Name", string_type], ["AdditionalName", string_type], ["SupplierArticleNumber", string_type], ["ConsumableId", string_type], ["ReceiverName", string_type], ["ReceiverId", string_type], ["SenderName", string_type], ["StorageId", string_type], ["Quantity", float64_type], ["ReceiverType", WasserNordConsumableReportReceiverType_$reflection()], ["Timestamp", class_type("System.DateTime")]]);
}

export class NotSolvedProblemReportEntry extends Record {
    constructor(ReportType, ToolId, ProblemReportId, Timestamp, SenderName, DisplayName, InititalMessage, SerialNumber, Model, Manufacturer, InventoryNumber) {
        super();
        this.ReportType = ReportType;
        this.ToolId = ToolId;
        this.ProblemReportId = ProblemReportId;
        this.Timestamp = Timestamp;
        this.SenderName = SenderName;
        this.DisplayName = DisplayName;
        this.InititalMessage = InititalMessage;
        this.SerialNumber = SerialNumber;
        this.Model = Model;
        this.Manufacturer = Manufacturer;
        this.InventoryNumber = InventoryNumber;
    }
}

export function NotSolvedProblemReportEntry_$reflection() {
    return record_type("Shared.Report.NotSolvedProblemReportEntry", [], NotSolvedProblemReportEntry, () => [["ReportType", ReportType_$reflection()], ["ToolId", ToolId_$reflection()], ["ProblemReportId", ProblemReportId_$reflection()], ["Timestamp", class_type("System.DateTime")], ["SenderName", string_type], ["DisplayName", string_type], ["InititalMessage", string_type], ["SerialNumber", string_type], ["Model", string_type], ["Manufacturer", string_type], ["InventoryNumber", string_type]]);
}

export class MinimumQuantityReportEntry extends Record {
    constructor(ToolId, ConsumableId, DisplayName, Model, Manufacturer, InventoryNumber, StorageName, StorageSpace, StorageStock, MinimumStock, CommercialData) {
        super();
        this.ToolId = ToolId;
        this.ConsumableId = ConsumableId;
        this.DisplayName = DisplayName;
        this.Model = Model;
        this.Manufacturer = Manufacturer;
        this.InventoryNumber = InventoryNumber;
        this.StorageName = StorageName;
        this.StorageSpace = StorageSpace;
        this.StorageStock = StorageStock;
        this.MinimumStock = MinimumStock;
        this.CommercialData = CommercialData;
    }
}

export function MinimumQuantityReportEntry_$reflection() {
    return record_type("Shared.Report.MinimumQuantityReportEntry", [], MinimumQuantityReportEntry, () => [["ToolId", option_type(ToolId_$reflection())], ["ConsumableId", option_type(ConsumableId_$reflection())], ["DisplayName", string_type], ["Model", string_type], ["Manufacturer", string_type], ["InventoryNumber", string_type], ["StorageName", string_type], ["StorageSpace", string_type], ["StorageStock", string_type], ["MinimumStock", string_type], ["CommercialData", CommercialData_$reflection()]]);
}

export class PlannedToolReturnDateEntry extends Record {
    constructor(ToolId, Date$, ReceiverName, DisplayName, Model, Manufacturer, InventoryNumber, SerialNumber) {
        super();
        this.ToolId = ToolId;
        this.Date = Date$;
        this.ReceiverName = ReceiverName;
        this.DisplayName = DisplayName;
        this.Model = Model;
        this.Manufacturer = Manufacturer;
        this.InventoryNumber = InventoryNumber;
        this.SerialNumber = SerialNumber;
    }
}

export function PlannedToolReturnDateEntry_$reflection() {
    return record_type("Shared.Report.PlannedToolReturnDateEntry", [], PlannedToolReturnDateEntry, () => [["ToolId", ToolId_$reflection()], ["Date", class_type("System.DateTime")], ["ReceiverName", string_type], ["DisplayName", string_type], ["Model", string_type], ["Manufacturer", string_type], ["InventoryNumber", string_type], ["SerialNumber", string_type]]);
}

export class ReleaseDateEntry extends Record {
    constructor(ReleaseDate, DisplayName, Model, Manufacturer, InventoryNumber, SerialNumber, ToolInformation, ReceiverInformation, StorageInformation) {
        super();
        this.ReleaseDate = ReleaseDate;
        this.DisplayName = DisplayName;
        this.Model = Model;
        this.Manufacturer = Manufacturer;
        this.InventoryNumber = InventoryNumber;
        this.SerialNumber = SerialNumber;
        this.ToolInformation = ToolInformation;
        this.ReceiverInformation = ReceiverInformation;
        this.StorageInformation = StorageInformation;
    }
}

export function ReleaseDateEntry_$reflection() {
    return record_type("Shared.Report.ReleaseDateEntry", [], ReleaseDateEntry, () => [["ReleaseDate", class_type("System.DateTime")], ["DisplayName", string_type], ["Model", string_type], ["Manufacturer", string_type], ["InventoryNumber", string_type], ["SerialNumber", string_type], ["ToolInformation", anonRecord_type(["Name", string_type], ["OnClickPath", list_type(string_type)], ["Quantity", option_type(string_type)], ["Unit", string_type])], ["ReceiverInformation", anonRecord_type(["CurrentReceiverName", string_type], ["CurrentReceiverOnClickPath", option_type(list_type(string_type))])], ["StorageInformation", anonRecord_type(["StorageName", string_type], ["StorageSpace", string_type])]]);
}

export class ReleaseDateReportResult extends Record {
    constructor(Rows) {
        super();
        this.Rows = Rows;
    }
}

export function ReleaseDateReportResult_$reflection() {
    return record_type("Shared.Report.ReleaseDateReportResult", [], ReleaseDateReportResult, () => [["Rows", list_type(ReleaseDateEntry_$reflection())]]);
}

export class NextReservationsEntry extends Record {
    constructor(StartDate, ReturnDate, ReservationName, DisplayName, Model, Manufacturer, ReservationId, GroupReservationId, InventoryNumber, SerialNumber, ToolInformation, ReceiverInformation) {
        super();
        this.StartDate = StartDate;
        this.ReturnDate = ReturnDate;
        this.ReservationName = ReservationName;
        this.DisplayName = DisplayName;
        this.Model = Model;
        this.Manufacturer = Manufacturer;
        this.ReservationId = ReservationId;
        this.GroupReservationId = GroupReservationId;
        this.InventoryNumber = InventoryNumber;
        this.SerialNumber = SerialNumber;
        this.ToolInformation = ToolInformation;
        this.ReceiverInformation = ReceiverInformation;
    }
}

export function NextReservationsEntry_$reflection() {
    return record_type("Shared.Report.NextReservationsEntry", [], NextReservationsEntry, () => [["StartDate", class_type("System.DateTime")], ["ReturnDate", class_type("System.DateTime")], ["ReservationName", string_type], ["DisplayName", string_type], ["Model", string_type], ["Manufacturer", string_type], ["ReservationId", string_type], ["GroupReservationId", option_type(string_type)], ["InventoryNumber", string_type], ["SerialNumber", string_type], ["ToolInformation", anonRecord_type(["Name", string_type], ["OnClickPath", list_type(string_type)], ["Quantity", option_type(string_type)], ["Unit", string_type])], ["ReceiverInformation", anonRecord_type(["CurrentReceiverName", string_type], ["CurrentReceiverOnClickPath", option_type(list_type(string_type))], ["ReceiverName", string_type], ["ReceiverNameOnClickPath", list_type(string_type)])]]);
}

export class PrinzingBaustromConstructionSiteReportResult extends Record {
    constructor(ConstructionSites) {
        super();
        this.ConstructionSites = ConstructionSites;
    }
}

export function PrinzingBaustromConstructionSiteReportResult_$reflection() {
    return record_type("Shared.Report.PrinzingBaustromConstructionSiteReportResult", [], PrinzingBaustromConstructionSiteReportResult, () => [["ConstructionSites", list_type(ConstructionSite_$reflection())]]);
}

export class SwissAthleticReportRow extends Record {
    constructor(LFDADRNR, Surname, FirstName, ClothingItem, LFDKLDNR, Date$, Pieces, Remark, Category) {
        super();
        this.LFDADRNR = LFDADRNR;
        this.Surname = Surname;
        this.FirstName = FirstName;
        this.ClothingItem = ClothingItem;
        this.LFDKLDNR = LFDKLDNR;
        this.Date = Date$;
        this.Pieces = Pieces;
        this.Remark = Remark;
        this.Category = Category;
    }
}

export function SwissAthleticReportRow_$reflection() {
    return record_type("Shared.Report.SwissAthleticReportRow", [], SwissAthleticReportRow, () => [["LFDADRNR", string_type], ["Surname", string_type], ["FirstName", string_type], ["ClothingItem", string_type], ["LFDKLDNR", string_type], ["Date", string_type], ["Pieces", string_type], ["Remark", string_type], ["Category", string_type]]);
}

export class SwissAthleticReportResult extends Record {
    constructor(Rows) {
        super();
        this.Rows = Rows;
    }
}

export function SwissAthleticReportResult_$reflection() {
    return record_type("Shared.Report.SwissAthleticReportResult", [], SwissAthleticReportResult, () => [["Rows", list_type(SwissAthleticReportRow_$reflection())]]);
}

export class InMaintenanceEntry extends Record {
    constructor(Date$, DisplayName, Model, Manufacturer, InventoryNumber, SerialNumber, ToolInformation, ReceiverInformation, StorageInformation) {
        super();
        this.Date = Date$;
        this.DisplayName = DisplayName;
        this.Model = Model;
        this.Manufacturer = Manufacturer;
        this.InventoryNumber = InventoryNumber;
        this.SerialNumber = SerialNumber;
        this.ToolInformation = ToolInformation;
        this.ReceiverInformation = ReceiverInformation;
        this.StorageInformation = StorageInformation;
    }
}

export function InMaintenanceEntry_$reflection() {
    return record_type("Shared.Report.InMaintenanceEntry", [], InMaintenanceEntry, () => [["Date", class_type("System.DateTime")], ["DisplayName", string_type], ["Model", string_type], ["Manufacturer", string_type], ["InventoryNumber", string_type], ["SerialNumber", string_type], ["ToolInformation", anonRecord_type(["Name", string_type], ["OnClickPath", list_type(string_type)], ["Quantity", option_type(string_type)], ["Unit", string_type])], ["ReceiverInformation", anonRecord_type(["CurrentReceiverName", string_type], ["CurrentReceiverOnClickPath", option_type(list_type(string_type))])], ["StorageInformation", anonRecord_type(["StorageName", string_type], ["StorageSpace", string_type])]]);
}

export class InMaintenanceReportResult extends Record {
    constructor(Rows) {
        super();
        this.Rows = Rows;
    }
}

export function InMaintenanceReportResult_$reflection() {
    return record_type("Shared.Report.InMaintenanceReportResult", [], InMaintenanceReportResult, () => [["Rows", list_type(InMaintenanceEntry_$reflection())]]);
}

export class StorageSwitchEntry extends Record {
    constructor(EntityInformation, Date$, DisplayName, SerialNumber, Model, Manufacturer, InventoryNumber, Quantity, Unit, SourceStorage, TargetStorage, CustomProperties, PurchasePrice) {
        super();
        this.EntityInformation = EntityInformation;
        this.Date = Date$;
        this.DisplayName = DisplayName;
        this.SerialNumber = SerialNumber;
        this.Model = Model;
        this.Manufacturer = Manufacturer;
        this.InventoryNumber = InventoryNumber;
        this.Quantity = Quantity;
        this.Unit = Unit;
        this.SourceStorage = SourceStorage;
        this.TargetStorage = TargetStorage;
        this.CustomProperties = CustomProperties;
        this.PurchasePrice = PurchasePrice;
    }
}

export function StorageSwitchEntry_$reflection() {
    return record_type("Shared.Report.StorageSwitchEntry", [], StorageSwitchEntry, () => [["EntityInformation", anonRecord_type(["Id", string_type], ["OnClickPath", list_type(string_type)])], ["Date", class_type("System.DateTime")], ["DisplayName", string_type], ["SerialNumber", string_type], ["Model", string_type], ["Manufacturer", string_type], ["InventoryNumber", string_type], ["Quantity", string_type], ["Unit", string_type], ["SourceStorage", string_type], ["TargetStorage", string_type], ["CustomProperties", list_type(CustomPropertyValueDto_$reflection())], ["PurchasePrice", option_type(int32_type)]]);
}

export class ConsumableAssignmentEntry extends Record {
    constructor(Id, Timestamp, ConsumableInformation, CommissionNumber, StorageName, ReceiverInformation, Quantity, CustomProperties) {
        super();
        this.Id = Id;
        this.Timestamp = Timestamp;
        this.ConsumableInformation = ConsumableInformation;
        this.CommissionNumber = CommissionNumber;
        this.StorageName = StorageName;
        this.ReceiverInformation = ReceiverInformation;
        this.Quantity = Quantity;
        this.CustomProperties = CustomProperties;
    }
}

export function ConsumableAssignmentEntry_$reflection() {
    return record_type("Shared.Report.ConsumableAssignmentEntry", [], ConsumableAssignmentEntry, () => [["Id", string_type], ["Timestamp", class_type("System.DateTime")], ["ConsumableInformation", anonRecord_type(["AdditionalName", string_type], ["Id", string_type], ["Name", string_type], ["OnClickPath", list_type(string_type)], ["Unit", string_type])], ["CommissionNumber", string_type], ["StorageName", string_type], ["ReceiverInformation", anonRecord_type(["Id", string_type], ["Name", string_type], ["OnClickPath", list_type(string_type)])], ["Quantity", float64_type], ["CustomProperties", list_type(CustomPropertyValueDto_$reflection())]]);
}

export class PrinzingInactiveToolEntry extends Record {
    constructor(ToolId, OnClickPath, LastEvent, LastEventDate, Manufacturer, Model, SerialNumber, DisplayName, Checknumber, InventoryNumber, IsToolWithQuantity, QrCodeIds, CustomProperties, CreatedAt, UpdatedAt) {
        super();
        this.ToolId = ToolId;
        this.OnClickPath = OnClickPath;
        this.LastEvent = LastEvent;
        this.LastEventDate = LastEventDate;
        this.Manufacturer = Manufacturer;
        this.Model = Model;
        this.SerialNumber = SerialNumber;
        this.DisplayName = DisplayName;
        this.Checknumber = Checknumber;
        this.InventoryNumber = InventoryNumber;
        this.IsToolWithQuantity = IsToolWithQuantity;
        this.QrCodeIds = QrCodeIds;
        this.CustomProperties = CustomProperties;
        this.CreatedAt = CreatedAt;
        this.UpdatedAt = UpdatedAt;
    }
}

export function PrinzingInactiveToolEntry_$reflection() {
    return record_type("Shared.Report.PrinzingInactiveToolEntry", [], PrinzingInactiveToolEntry, () => [["ToolId", string_type], ["OnClickPath", list_type(string_type)], ["LastEvent", option_type(ToolEvent_$reflection())], ["LastEventDate", option_type(class_type("System.DateTime"))], ["Manufacturer", string_type], ["Model", string_type], ["SerialNumber", string_type], ["DisplayName", string_type], ["Checknumber", string_type], ["InventoryNumber", string_type], ["IsToolWithQuantity", bool_type], ["QrCodeIds", string_type], ["CustomProperties", list_type(CustomPropertyValueDto_$reflection())], ["CreatedAt", class_type("System.DateTime")], ["UpdatedAt", class_type("System.DateTime")]]);
}

export class DuplicateCheckEntryToolType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Tool", "ToolWithQuantity", "Set", "Consumable"];
    }
}

export function DuplicateCheckEntryToolType_$reflection() {
    return union_type("Shared.Report.DuplicateCheckEntryToolType", [], DuplicateCheckEntryToolType, () => [[], [], [], []]);
}

export class DuplicateCheckEntry extends Record {
    constructor(Id, ToolType, Manufacturer, Model, SerialNumber, DisplayName, Checknumber, InventoryNumber, QrCodeIds, CustomProperties, CreatedAt) {
        super();
        this.Id = Id;
        this.ToolType = ToolType;
        this.Manufacturer = Manufacturer;
        this.Model = Model;
        this.SerialNumber = SerialNumber;
        this.DisplayName = DisplayName;
        this.Checknumber = Checknumber;
        this.InventoryNumber = InventoryNumber;
        this.QrCodeIds = QrCodeIds;
        this.CustomProperties = CustomProperties;
        this.CreatedAt = CreatedAt;
    }
}

export function DuplicateCheckEntry_$reflection() {
    return record_type("Shared.Report.DuplicateCheckEntry", [], DuplicateCheckEntry, () => [["Id", string_type], ["ToolType", DuplicateCheckEntryToolType_$reflection()], ["Manufacturer", string_type], ["Model", string_type], ["SerialNumber", string_type], ["DisplayName", string_type], ["Checknumber", string_type], ["InventoryNumber", string_type], ["QrCodeIds", string_type], ["CustomProperties", list_type(CustomPropertyValueDto_$reflection())], ["CreatedAt", class_type("System.DateTime")]]);
}

export class UninspectedToolStatus extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["NeverInspected", "InspectionExpired", "InspectionFailed"];
    }
}

export function UninspectedToolStatus_$reflection() {
    return union_type("Shared.Report.UninspectedToolStatus", [], UninspectedToolStatus, () => [[], [], []]);
}

export class UninspectedToolEntry extends Record {
    constructor(Inventory, Status, InspectionTemplateNames) {
        super();
        this.Inventory = Inventory;
        this.Status = Status;
        this.InspectionTemplateNames = InspectionTemplateNames;
    }
}

export function UninspectedToolEntry_$reflection() {
    return record_type("Shared.Report.UninspectedToolEntry", [], UninspectedToolEntry, () => [["Inventory", ReportInventoryDto_$reflection()], ["Status", UninspectedToolStatus_$reflection()], ["InspectionTemplateNames", list_type(string_type)]]);
}

export class UninspectedToolsResult extends Record {
    constructor(Rows, TotalInspectionRequiredCount, InspectedCount, ExpiredCount, NeverInspectedCount, FailedCount) {
        super();
        this.Rows = Rows;
        this.TotalInspectionRequiredCount = (TotalInspectionRequiredCount | 0);
        this.InspectedCount = (InspectedCount | 0);
        this.ExpiredCount = (ExpiredCount | 0);
        this.NeverInspectedCount = (NeverInspectedCount | 0);
        this.FailedCount = (FailedCount | 0);
    }
}

export function UninspectedToolsResult_$reflection() {
    return record_type("Shared.Report.UninspectedToolsResult", [], UninspectedToolsResult, () => [["Rows", list_type(UninspectedToolEntry_$reflection())], ["TotalInspectionRequiredCount", int32_type], ["InspectedCount", int32_type], ["ExpiredCount", int32_type], ["NeverInspectedCount", int32_type], ["FailedCount", int32_type]]);
}

export class InspectionStatisticsEntry extends Record {
    constructor(InspectionTemplateName, InspectionDate, ResultStatus, Result, Comment$, Inventory) {
        super();
        this.InspectionTemplateName = InspectionTemplateName;
        this.InspectionDate = InspectionDate;
        this.ResultStatus = ResultStatus;
        this.Result = Result;
        this.Comment = Comment$;
        this.Inventory = Inventory;
    }
}

export function InspectionStatisticsEntry_$reflection() {
    return record_type("Shared.Report.InspectionStatisticsEntry", [], InspectionStatisticsEntry, () => [["InspectionTemplateName", string_type], ["InspectionDate", class_type("System.DateTime")], ["ResultStatus", string_type], ["Result", string_type], ["Comment", string_type], ["Inventory", ReportInventoryDto_$reflection()]]);
}

export class InspectionStatisticsResult extends Record {
    constructor(Rows, TotalCount, PassedCount, FailedCount) {
        super();
        this.Rows = Rows;
        this.TotalCount = (TotalCount | 0);
        this.PassedCount = (PassedCount | 0);
        this.FailedCount = (FailedCount | 0);
    }
}

export function InspectionStatisticsResult_$reflection() {
    return record_type("Shared.Report.InspectionStatisticsResult", [], InspectionStatisticsResult, () => [["Rows", list_type(InspectionStatisticsEntry_$reflection())], ["TotalCount", int32_type], ["PassedCount", int32_type], ["FailedCount", int32_type]]);
}

export class ConsumableOutputSummedEntry extends Record {
    constructor(ConsumableInformation, StorageName, Quantity, InventoryData) {
        super();
        this.ConsumableInformation = ConsumableInformation;
        this.StorageName = StorageName;
        this.Quantity = Quantity;
        this.InventoryData = InventoryData;
    }
}

export function ConsumableOutputSummedEntry_$reflection() {
    return record_type("Shared.Report.ConsumableOutputSummedEntry", [], ConsumableOutputSummedEntry, () => [["ConsumableInformation", anonRecord_type(["AdditionalName", string_type], ["Id", string_type], ["Name", string_type], ["OnClickPath", list_type(string_type)], ["Unit", string_type])], ["StorageName", string_type], ["Quantity", float64_type], ["InventoryData", ReportInventoryDto_$reflection()]]);
}

export class InspectionCalendarStatus extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Upcoming", "Overdue", "NeverInspected"];
    }
}

export function InspectionCalendarStatus_$reflection() {
    return union_type("Shared.Report.InspectionCalendarStatus", [], InspectionCalendarStatus, () => [[], [], []]);
}

export class InspectionCalendarEntry extends Record {
    constructor(Inventory, NextInspectionDate, LastInspectionDate, InspectionTemplateNames, Status) {
        super();
        this.Inventory = Inventory;
        this.NextInspectionDate = NextInspectionDate;
        this.LastInspectionDate = LastInspectionDate;
        this.InspectionTemplateNames = InspectionTemplateNames;
        this.Status = Status;
    }
}

export function InspectionCalendarEntry_$reflection() {
    return record_type("Shared.Report.InspectionCalendarEntry", [], InspectionCalendarEntry, () => [["Inventory", ReportInventoryDto_$reflection()], ["NextInspectionDate", option_type(class_type("System.DateTime"))], ["LastInspectionDate", option_type(class_type("System.DateTime"))], ["InspectionTemplateNames", list_type(string_type)], ["Status", InspectionCalendarStatus_$reflection()]]);
}

export class InspectionCalendarResult extends Record {
    constructor(Rows, UpcomingCount, OverdueCount, NeverInspectedCount) {
        super();
        this.Rows = Rows;
        this.UpcomingCount = (UpcomingCount | 0);
        this.OverdueCount = (OverdueCount | 0);
        this.NeverInspectedCount = (NeverInspectedCount | 0);
    }
}

export function InspectionCalendarResult_$reflection() {
    return record_type("Shared.Report.InspectionCalendarResult", [], InspectionCalendarResult, () => [["Rows", list_type(InspectionCalendarEntry_$reflection())], ["UpcomingCount", int32_type], ["OverdueCount", int32_type], ["NeverInspectedCount", int32_type]]);
}

export class ReportResultDto extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ConsumableByCommissionnumber", "ProblemReportsPerTool", "Appointments", "NewToolsByDateRange", "SchoeffmannRetiredToolsWithQRCodeId", "ReservationsByDateRange", "SchoeffmannActiveAndInMaintenanceToolWithQRCodeId", "PrinzingToolAssignedToReport", "MissedAppointments", "SchoeffmannUserReport", "SBucherConstructionSiteReport", "WasserNordConsumableReport", "ToolsWithNoReservationsByDateRange", "PrinzingGroupedToolsReport", "NotSolvedProblemReports", "OpenAppointmentsReport", "MinimumQuantityReport", "PlannedToolReturnDate", "NextReservations", "PrinzingBaustromConstructionSiteReport", "SwissAthleticReport", "InMaintenanceReport", "PrinzingHebebuehnenConstructionSiteReport", "ReleaseDate", "RetiredLostToolsByDateRange", "StorageSwitch", "ConsumableAssignment", "PrinzingInactiveTools", "DuplicateCheck", "UninspectedTools", "InspectionStatistics", "ConsumableOutputSummed", "InspectionCalendar", "NotFound"];
    }
}

export function ReportResultDto_$reflection() {
    return union_type("Shared.Report.ReportResultDto", [], ReportResultDto, () => [[["Item", list_type(ConsumableByCommissionnumber_$reflection())]], [["Item", list_type(ProblemReportsPerTool_$reflection())]], [["Item", list_type(OpenAppointment_$reflection())]], [["Item", list_type(InventoryEntries_$reflection())]], [["Item", list_type(SchoeffmannRetiredToolWithQRCodeId_$reflection())]], [["Item", list_type(ReservationsByDateRangeReportItem_$reflection())]], [["Item", list_type(SchoeffmannActiveAndInMaintenanceToolWithQRCodeId_$reflection())]], [["Item", list_type(PrinzingToolAssignedTo_$reflection())]], [["Item", list_type(OpenAppointment_$reflection())]], [["Item", list_type(SchoeffmannUserReport_$reflection())]], [["Item", list_type(SBucherConstructionSiteReport_$reflection())]], [["Item", list_type(WasserNordConsumableReport_$reflection())]], [["Item", list_type(ToolWithoutReservationsByDateRangeReportItem_$reflection())]], [], [["Item", list_type(NotSolvedProblemReportEntry_$reflection())]], [["Item", list_type(OpenAppointment_$reflection())]], [["Item", list_type(MinimumQuantityReportEntry_$reflection())]], [["Item", list_type(PlannedToolReturnDateEntry_$reflection())]], [["Item", list_type(NextReservationsEntry_$reflection())]], [["Item", PrinzingBaustromConstructionSiteReportResult_$reflection()]], [["Item", SwissAthleticReportResult_$reflection()]], [["Item", InMaintenanceReportResult_$reflection()]], [["Item", PrinzingBaustromConstructionSiteReportResult_$reflection()]], [["Item", ReleaseDateReportResult_$reflection()]], [["Item", list_type(InventoryEntries_$reflection())]], [["Item", list_type(StorageSwitchEntry_$reflection())]], [["Item", list_type(ConsumableAssignmentEntry_$reflection())]], [["Item", list_type(PrinzingInactiveToolEntry_$reflection())]], [["Item", list_type(DuplicateCheckEntry_$reflection())]], [["Item", UninspectedToolsResult_$reflection()]], [["Item", InspectionStatisticsResult_$reflection()]], [["Item", list_type(ConsumableOutputSummedEntry_$reflection())]], [["Item", InspectionCalendarResult_$reflection()]], []]);
}

export class DuplicateCheckType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["InventoryNumber", "SerialNumber"];
    }
    toString() {
        const this$ = this;
        return (this$.tag === 1) ? "serialNumber" : "inventoryNumber";
    }
}

export function DuplicateCheckType_$reflection() {
    return union_type("Shared.Report.DuplicateCheckType", [], DuplicateCheckType, () => [[], []]);
}

export const Helper_reports = ofArray([new Report(new ReportType(0, []), true, empty(), 1, "report.report_select_consumables_per_commission", new ReportCategory(3, [])), new Report(new ReportType(1, []), true, empty(), 2, "report.report_select_problems_per_tool", new ReportCategory(4, [])), new Report(new ReportType(2, []), true, empty(), 3, "report.report_select_appointments", new ReportCategory(1, [])), new Report(new ReportType(3, []), true, empty(), 4, "report.report_select_tools_created_by_daterange", new ReportCategory(2, [])), new Report(new ReportType(4, []), true, singleton(new Customer(3, [])), 5, "report.report_select_schoeffmann_retired_tools", new ReportCategory(0, [])), new Report(new ReportType(6, []), true, empty(), 6, "report.report_select_reservations_by_daterange", new ReportCategory(1, [])), new Report(new ReportType(5, []), false, singleton(new Customer(3, [])), 7, "report.report_select_schoeffmann_active_and_in_maintenance_tools", new ReportCategory(0, [])), new Report(new ReportType(7, []), false, singleton(new Customer(1, [])), 8, "report.report_select_prinzing_last_comment_assigned_tool", new ReportCategory(0, [])), new Report(new ReportType(8, []), false, empty(), 9, "report.report_select_appointments_missed", new ReportCategory(1, [])), new Report(new ReportType(9, []), false, singleton(new Customer(3, [])), 10, "report.report_select_schoeffmann_user_report", new ReportCategory(0, [])), new Report(new ReportType(10, []), true, singleton(new Customer(4, [])), 11, "report.report_select_sbucher_construction_site_report", new ReportCategory(0, [])), new Report(new ReportType(11, []), false, singleton(new Customer(5, [])), 12, "report.report_select_wassernord_consumable", new ReportCategory(0, [])), new Report(new ReportType(12, []), true, empty(), 13, "report.report_select_without_reservations_by_daterange", new ReportCategory(1, [])), new Report(new ReportType(13, []), false, singleton(new Customer(1, [])), 15, "report.prinzing.grouped_tools_report", new ReportCategory(0, [])), new Report(new ReportType(14, []), false, empty(), 16, "report.not_solved_problem_report_title", new ReportCategory(4, [])), new Report(new ReportType(15, []), true, empty(), 17, "report.open_appointments_report_title", new ReportCategory(1, [])), new Report(new ReportType(16, []), false, empty(), 18, "report.minimum_quantity_report_title", new ReportCategory(2, [])), new Report(new ReportType(17, []), false, empty(), 19, "dashboard.tool_return_date_title", new ReportCategory(1, [])), new Report(new ReportType(18, []), false, empty(), 20, "dashboard.tool_next_reservations_title", new ReportCategory(1, [])), new Report(new ReportType(19, []), false, singleton(new Customer(7, [])), 21, "report.report_select_prinzing_baustrom", new ReportCategory(0, [])), new Report(new ReportType(20, []), true, singleton(new Customer(8, [])), 22, "report.report_select_swiss_athletic", new ReportCategory(0, [])), new Report(new ReportType(21, []), false, empty(), 23, "general.in_maintenance", new ReportCategory(2, [])), new Report(new ReportType(22, []), false, singleton(new Customer(1, [])), 24, "report.report_select_prinzing_hebebuehnen", new ReportCategory(0, [])), new Report(new ReportType(23, []), false, empty(), 25, "general.release_date", new ReportCategory(1, [])), new Report(new ReportType(24, []), true, empty(), 26, "report.report_retired_lost_tools", new ReportCategory(2, [])), new Report(new ReportType(25, []), true, empty(), 27, "report.report_storage_switch", new ReportCategory(2, [])), new Report(new ReportType(26, []), true, empty(), 28, "report.report_consumable_assignment", new ReportCategory(3, [])), new Report(new ReportType(27, []), true, singleton(new Customer(1, [])), 29, "report.report_select_prinzing_inactive_tools", new ReportCategory(0, [])), new Report(new ReportType(28, []), false, empty(), 30, "report.report_duplicate_check", new ReportCategory(2, [])), new Report(new ReportType(29, []), false, empty(), 31, "report.report_uninspected_tools", new ReportCategory(5, [])), new Report(new ReportType(30, []), true, empty(), 32, "report.report_inspection_statistics", new ReportCategory(5, [])), new Report(new ReportType(31, []), true, empty(), 33, "report.report_consumable_output_summed", new ReportCategory(3, [])), new Report(new ReportType(32, []), true, empty(), 34, "report.report_inspection_calendar", new ReportCategory(5, []))]);

export function Helper_categoryI18NLabel(_arg) {
    switch (_arg.tag) {
        case 1:
            return "report.category_appointments_and_reservations";
        case 2:
            return "report.category_inventory_and_stock";
        case 3:
            return "report.category_consumables";
        case 4:
            return "report.category_problem_reports";
        case 5:
            return "report.category_inspections";
        default:
            return "report.category_customer_reports";
    }
}

export function Helper_categoryOrder(_arg) {
    switch (_arg.tag) {
        case 1:
            return 1;
        case 2:
            return 2;
        case 3:
            return 3;
        case 4:
            return 4;
        case 5:
            return 5;
        default:
            return 0;
    }
}

export function Helper_hasReportDaterangeOption(reportId) {
    const res = tryFind((r) => (r.Id === reportId), Helper_reports);
    if (res == null) {
        return false;
    }
    else {
        return res.WithDaterange;
    }
}

export function Helper_reportById(reportId) {
    return tryFind((r) => (r.Id === reportId), Helper_reports);
}

export function Helper_stringToDuplicateCheckType(value) {
    switch (value) {
        case "serialNumber":
            return new DuplicateCheckType(1, []);
        case "inventoryNumber":
            return new DuplicateCheckType(0, []);
        default:
            return undefined;
    }
}

